import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { ButtonFilterStyle } from "./ButtonFilterStyle";

interface Props {
  children: React.ReactNode;
  name: string;
}

export const Filter: React.FC<Props> = ({ children, name }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const paramValue = searchParams.get(name);
  const active2 = paramValue == "true" || false;

  const handleClick = () => {
    if (paramValue != null) {
      searchParams.delete(name);
    } else {
      searchParams.set(name, "true");
    }
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <ButtonFilterStyle onClick={handleClick} active={active2}>
      <Flex px="3" alignItems="center">
        <Text as="span">{children}</Text>
      </Flex>
    </ButtonFilterStyle>
  );
};
